export default {
    duplicate: 'Duplicate',
    invalid: 'Invalid',
    lost: 'Lost',
    active: 'Active',
};
